import { useState } from 'react';

import SelectItemType from './components/addCartItemDialog/SelectItemType';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { CART_ITEM_TYPE } from './enums';

import SelectOffering from '@/app/offering/SelectOffering';

import Spinner from '@/components/common/Spinner';

import { useOfferings } from '@/data/offering';
import { useCoachSelf } from '@/data/coach';

const AddCartItemDialog = ({ cartId, onClose, onSuccess }) => {
  const coach = useCoachSelf();
  const [itemType, setItemType] = useState(CART_ITEM_TYPE.OFFERING);
  const offerings = useOfferings({ coachId: coach.data.id });

  const onHandleSuccess = async (newCartItem) => {
    await onSuccess(newCartItem);
    onClose();
  };

  let content = (
    <div className="flex justify-center items-center h-[200px]">
      <Spinner />
    </div>
  );

  if (offerings.data) {
    content = <SelectOffering cartId={cartId} onSuccess={onHandleSuccess} />;
  }
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-[90vw] px-2 rounded-lg">
        <DialogHeader className="mb-4">
          <DialogTitle>Add Cart Item</DialogTitle>
        </DialogHeader>
        <SelectItemType itemType={itemType} setItemType={setItemType} />
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default AddCartItemDialog;
